import { render, staticRenderFns } from "./DisponibilitaMateria.vue?vue&type=template&id=bdb3eed0&scoped=true"
import script from "./DisponibilitaMateria.vue?vue&type=script&lang=js"
export * from "./DisponibilitaMateria.vue?vue&type=script&lang=js"
import style0 from "./DisponibilitaMateria.vue?vue&type=style&index=0&id=bdb3eed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb3eed0",
  null
  
)

export default component.exports